import React, { useContext } from 'react';
import { Button } from '@one-thd/sui-atomic-components';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { ORDER_DETAILS_URL } from './constants';
import { buildQueryString, isLockerPickupEligible } from './utils';
import { PickupLockerQRCode } from './PickupLockerQRCode';

// Ported one-to-one from @thd-olt-component-react/active-orders' FulfillmentDetailsActions.tsx
// (OOP-4059) — see FulfillmentDetailsDrawer.tsx's doc comment. Drops the unused `customerType`
// prop the source component accepted but never read.
export interface FulfillmentDetailsActionsProps {
  fulfillmentGroup?: any;
}

export const FulfillmentDetailsActions: React.FC<FulfillmentDetailsActionsProps> = ({ fulfillmentGroup }) => {
  const { channel, isConsumerApp } = useContext(ExperienceContext);
  const isMobile = channel === 'mobile';

  if (!fulfillmentGroup) return null;

  const {
    orderNumber,
    orderNumbers,
    orderOrigin,
    salesDate,
    transactionId,
    registerNumber,
    storeNumber,
    deliveryTrackerData
  } = fulfillmentGroup;
  const trackingUrl = deliveryTrackerData?.links?.internalTrackingUrl || deliveryTrackerData?.links?.deliveryTrackerUrl || '';

  const orderDetailsUrl = `${ORDER_DETAILS_URL}${buildQueryString({
    orderNumber,
    orderNumbers,
    orderOrigin,
    salesDate,
    transactionId,
    registerNumber,
    storeNumber
  })}`;

  const lockerPickupEligible = isLockerPickupEligible(fulfillmentGroup, isMobile, Boolean(isConsumerApp));

  return (
    <div className="sui-flex sui-flex-col sui-w-full sui-gap-2" data-testid="fulfillment-details-actions">
      {trackingUrl && (
        <Button fullWidth href={trackingUrl}>
          Track Shipment
        </Button>
      )}
      <Button fullWidth variant={trackingUrl ? 'secondary' : 'primary'} href={orderDetailsUrl}>
        View Order Details
      </Button>
      {lockerPickupEligible && <PickupLockerQRCode orderNumber={orderNumber} fulfillmentGroup={fulfillmentGroup} buttonVariant="primary" />}
    </div>
  );
};
